import { useQuery } from '@tanstack/react-query';

import api from 'api';
import type { ClientHistoryResponse } from 'types';
import { getErrorStatus } from 'utils/v2/errorHelper';

export const clientHistoryKeys = {
    all: ['clientHistory'] as const,
    byClient: (candidateId: number | null, page: number, perPage: number) =>
        ['clientHistory', candidateId, page, perPage] as const,
};

export const useClientHistory = (
    candidateId: number | null,
    params: { page: number; perPage: number },
    options?: { enabled?: boolean }
) =>
    useQuery<ClientHistoryResponse>({
        queryKey: clientHistoryKeys.byClient(candidateId, params.page, params.perPage),
        queryFn: async () => {
            const response = await api.clientHistory.get(candidateId as number, {
                page: params.page,
                per_page: params.perPage,
            });
            return response.data;
        },
        enabled: (options?.enabled ?? true) && candidateId !== null,
        retry: (failureCount, error) => {
            const status = getErrorStatus(error);
            if (status === 403 || status === 404) return false;
            return failureCount < 2;
        },
        staleTime: 60 * 1000,
    });
